"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useCharCountStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    charCount: {
      textAlign: 'right'
    },
    charCountError: {
      color: theme.palette.RED400
    }
  };
});
var _default = useCharCountStyles;
exports.default = _default;